import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAdminReviewQueue, type ReviewQueueParams } from '../lib/api'
import { fmtDateTime } from '../lib/format'

const STATUS_TONE: Record<string, string> = {
  pending:  'admin-pill admin-pill--warning',
  assigned: 'admin-pill admin-pill--info',
  decided:  'admin-pill admin-pill--success',
}

export function ReviewQueuePage() {
  const [params, setParams] = useState<ReviewQueueParams>({ page: 1, perPage: 50 })
  const q = useAdminReviewQueue(params)

  return (
    <>
      <header className="page-header">
        <div className="page-header__title-row">
          <h1 className="page-header__title">Phase 3 Reviews</h1>
          <span className="page-header__subtitle">Accounts awaiting reviewer decision before funded.</span>
        </div>
      </header>

      <div className="filter-bar" style={{ marginBottom: 'var(--space-4)' }}>
        <div className="filter-bar__group">
          <label className="field__label" htmlFor="review-status">Status</label>
          <select
            id="review-status"
            className="field__input"
            style={{ width: 180 }}
            value={params.status ?? ''}
            onChange={(e) => setParams((p) => ({ ...p, status: e.target.value || undefined, page: 1 }))}
          >
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="assigned">Assigned</option>
            <option value="decided">Decided</option>
          </select>
        </div>
      </div>

      <div className="admin-table">
        <table>
          <thead>
            <tr>
              <th>Trader</th>
              <th>Status</th>
              <th>Composite score</th>
              <th>Assigned reviewer</th>
              <th>Created</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {q.isLoading && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>Loading…</td></tr>
            )}
            {q.data && q.data.reviews.length === 0 && (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-tertiary)' }}>Queue is empty.</td></tr>
            )}
            {q.data && q.data.reviews.map((r) => (
              <tr key={r.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{r.user?.displayName ?? '—'}</div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
                    {r.user?.email ?? r.userId}
                  </div>
                </td>
                <td><span className={STATUS_TONE[r.status] ?? 'admin-pill'}>{r.status}</span></td>
                <td style={{ fontFamily: 'var(--font-mono)' }}>{r.composite != null ? r.composite.toFixed(1) : '—'}</td>
                <td style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)' }}>{r.assignedReviewerId ?? '—'}</td>
                <td style={{ color: 'var(--text-secondary)' }}>{fmtDateTime(r.createdAt)}</td>
                <td style={{ textAlign: 'right' }}>
                  <Link to={`/reviews/${r.id}`} className="btn btn--secondary btn--sm">Open</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}
